import * as VacationService from "@/services/vacation";
import useRequest from "@/composables/useRequest";
import { computed, ref } from "@nuxtjs/composition-api";
import { dayjs } from "@/utils/helpers";
// import { whenever } from "@vueuse/core";
export default function useVacationSotck(product_no) {
  const { state: dates, execute: fetchDate } = useRequest(
    () => VacationService.getProductDates({ product_no }),
    [],
    {
      immediate: false
    }
  );

  const flatStocks = computed(() => {
    return dates.value.map(item => item.dates).flat();
  });

  

  const selectedStock = ref({});

  // 城市
  const { state: citys, execute: fetchDist } = useRequest(
    () =>
      VacationService.getProductDst({
        product_no,
        date: selectedStock.value.date
      }),
    [],
    {
      immediate: false
    }
  );

  // whenever(isReady, () => {
  //   if (flatStocks.value.length) {
  //     selectedStock.value = head(flatStocks.value);
  //   }
  // });

  // watchEffect(() => {
  //   if (selectedStock.value.date) {
  //     fetchDist(0);
  //   }
  // });

  return {
    fetchDate,
    fetchDist,

    dates,
    citys,
    flatStocks,
    // monthNavs,
    selectedStock
  };
}
